import { SelectItem } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/primeng';
import { Carrier } from './carrier';
import { CarrierService } from './carrier.service';
import { ContainerItem } from './carrieritem';
import { State, CarrierType, ScannerType, MaterialType } from './carrier-enum';
import { SelectableLab } from './selectable-lab'
import { CompleteScanRequest } from './completeScanRequest';
import { PrintRequest } from './print-request';
import { saveAs as saveByFileSaver } from "file-saver";
import { BBAPIError } from './api-error';
import { ActivatedRoute } from '@angular/router';
import { ErrorHandler } from "../utils/error-handler"
import { MessagesService } from '../messages/messages.service';
import { Sample } from './sample';
import { Primer } from './Primer';
import { ContainerType } from '../container-view/models/container-type-enum';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
import { Printer } from '../masterdata/models/printer';
import { CarrierState } from '../masterdata/models/carrierState';
import { ProcessStep } from '../masterdata/models/processStep-enum';


@Component({
  templateUrl: './carrier.component.html',
  styleUrls: ['./carrier.component.css']
})

export class CarrierComponent implements OnInit {

  carriers: Carrier[];
  selectedCarrier: Carrier;
  carrierToBeDeleted: Carrier;
  cols: any[];
  errorMessage: string;

  dates: Date[] = [];
  newCarrierItemsMenu: MenuItem[];

  gridSelection: SelectItem[];

  errorHandler: ErrorHandler = new ErrorHandler;
  displayLRPlatesDialog: boolean = false;
  displayDeleteDialog: boolean = false;
  displaySaveBarcodesDialog = false;
  deleteIndex: number;
  totalRecords: number = 0;
  pageIndex: number = 0;
  hasToggle: boolean = true;
  dynamicGridRows: number;
  dynamicGridColumns: number;

  rowCol = {
    row: null, col: null
  };

  enteredRackBarcode = '';
  enteredPlateBarcode: string;
  alphabet: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  number: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  carrierState: string;
  checkedLP: boolean = false;
  checkedWIP: boolean = true;
  checkedSC: boolean = true;
  headerColumns: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  headerRows: string[] = ["A", "B", "C", "D", "E", "F", "G", "H"];
  deleteConfirmed: boolean = false;
  blocked: boolean;
  carrierNode: Carrier;
  displayItemsDialog: boolean = false;
  TabToclose: number;
  bbApiError: BBAPIError = null;
  selectedLab: SelectableLab;
  //to avaoid ExpressionChangedAfterItHasBeenCheckedError, Set to True
  carrierLoading: boolean = true;
  fromDate: Date = new Date();
  enableDownloadTRTFile = true;
  disableScanCompleteOnError = true;

  uploadForm: FormGroup;
  isLoadStandardPrimerPlate: boolean = false;

  buildNo: string;

  printersList: Printer[];
  selectedPrinter: Printer;

  carrierStateDetails: CarrierState;
  processStep: string;

  isUploadDisabled = true;
  isHamiltonRack = false;
  HamiltonRackDialog = false;
  link: MenuItem[];
  enableHamiltonRackFeature = false;
  containerItems: Array<ContainerItem> = new Array<ContainerItem>();
  disableSaveButton = false;
  storeLocationForHamiltonRack: string;
  storeLocation: string;
  storeVertical: boolean;
  constructor(private _carrierService: CarrierService, private route: ActivatedRoute, private messagesService: MessagesService, private carrierStatusService: CarrierStatusService, private formBuilder: FormBuilder) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
    _carrierService.getBuildInfo().subscribe(
      results => {
        console.log(results);
      }
    );

    this.gridSelection = [
      { label: '96 Well Plate', value: { row: 8, col: 12 } },
      { label: 'Tube Box', value: { row: 10, col: 10 } },
      { label: 'Load Standard Primer Plate', value: { row: 0, col: 0 } }
    ];


  }

  refreshData() {
    this.pageIndex = 0;
    this.totalRecords = 0;
    this.carriers = [];
    this.rowCol = null

    if (!this.checkedWIP && !this.checkedSC && !this.checkedLP) {
      return;
    }

    else {
      console.log("WIP: " + this.checkedWIP + " SC: " + this.checkedSC + " LP: " + this.checkedLP);
      this.loadDataOnScroll();
    }
  }

  loadDataOnScroll() {
    this.selectedLab = this.selectedLab;
    console.log("Lab in carrier comp :" + this.selectedLab.lab);

    if (!this.checkedWIP && !this.checkedSC && !this.checkedLP) {
      this.carriers = []
    }
    else {
      this.carrierLoading = true;
      if (this.totalRecords == 0) {
        this._carrierService.getCarrierCount(this.selectedLab.lab, this.fromDate.toDateString(), this.checkedWIP, this.checkedSC, this.checkedLP).subscribe(
          results => {
            if (!results) {
              this.carrierLoading = false;
              return;
            }
            console.log("results Count:", results.data);
            this.totalRecords = results.data;
            this.carrierLoading = false;
          }
        )
      }

      this._carrierService.getCarrier(this.selectedLab.lab, this.pageIndex, this.fromDate.toDateString(), this.checkedWIP, this.checkedSC, this.checkedLP).subscribe(
        results => {
          if (!results) {
            this.carrierLoading = false;
            return;
          }
          console.log("results:", results.data);
          this.carriers = ((this.carriers != undefined) ? this.carriers.concat(results.data) : results.data);
          console.log("on scroll size " + this.carriers.length);
          this.updateCarrierVisibility();
          this.carrierLoading = false;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.carrierLoading = false;
        }
      );

      this.pageIndex = this.pageIndex + 1;
      console.log('records are added now')
    }
  }

  ngOnInit() {
    var features = JSON.parse(localStorage.getItem("features"));
    this.enableHamiltonRackFeature = true;
    if (features) {
      features.forEach(item => {
        if (item != null && item != undefined && item.featureName === "hamiltonRackScan")
          this.enableHamiltonRackFeature = item.isActive;
      });
    }
    this.fromDate.setDate(this.fromDate.getDate() - 2)
    this.carrierState = "WIP";
    this.cols = [
      { field: 'barcode', header: 'Carrier' },
      { field: 'state', header: 'State' },
      { field: 'carrierItems', header: ' Samples' },
      { field: 'errors', header: 'Errors' }
    ];

    this.link = [
      {
        label: 'Premixed', command: () => {
          this.addNewCarrier(CarrierType.TUBE_CARRIER)
        }
      },
      {
        label: 'SR Tube', command: () => {
          this.addNewSupremeRunCarrier()
        }
      },

      (this.enableHamiltonRackFeature ?
        {
          label: 'Hamilton Rack', command: () => {
            this.HamiltonRackDialog = true;
          }
        }
        : {})

    ];


    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    //get Sample_Reception MDM configuration
    this.processStep = ProcessStep.SAMPLE_RECEPTION;
    this.getProcessStepDetail(this.processStep);
  }

  onRowSelect(event) {
    this.enableDownloadTRTFile = true;
    this.disableScanCompleteOnError = true;
    this.storeVertical = false;
    event.data != null && event.data != undefined && event.data.carrierType === CarrierType.HAMILTON_RACK ? this.isHamiltonRack = true : this.isHamiltonRack = false;
    this.isLoadStandardPrimerPlate = false;
    this.rowCol = null;
    //prevent the back end call if carrier id is null
    if (event.data._id != null && event.data._id != undefined) {
      this.blocked = true;
      this._carrierService.getcarrierById(event.data._id).subscribe(result => {
        if (!result || !result.data) {
          return;
        }
        this.selectedCarrier = result.data;
        this.setDynamicGridDimensions();
        if (!this.selectedCarrier.isOpenForEdit) {
          this.selectedCarrier.isOpenForEdit = true;
        }
        this.checkForDuplicates();

        for (let i = 0; i < this.carriers.length; i++) {
          if (this.carriers[i]._id == this.selectedCarrier._id) {
            this.carriers[i] = this.selectedCarrier;
            break;
          }
        }

        if (result.data.carrierStatus != null && result.data.carrierStatus != undefined) {
          /*
          check the carrierStatus array if any inconsitency exists then show appropriate info in the UI
          */
          for (let i = 0; i < result.data.carrierStatus.length; i++) {
            if (result.data.carrierStatus[i].statusCode == "EmptyCarrier") {
              this.disableSaveButton = true;
              this.messagesService.addErrorMessage({ severity: 'error', summary: 'Empty carrier', detail: result.data.carrierStatus[i].barcode + ' rack is empty.' });
            }
            else if (result.data.carrierStatus[i].statusCode == "NonExistingCarrier") {
              this.disableSaveButton = true;
              this.messagesService.addErrorMessage({ severity: 'error', summary: 'Non existing carrier', detail: result.data.carrierStatus[i].barcode + ' not found in BB database.' });
            }
            else if (result.data.carrierStatus[i].statusCode == "InconsistentCarrier") {
              this.disableSaveButton = true;
              let differntMaterialType = result.data.carrierStatus[i].materialType != null && result.data.carrierStatus[i].materialType != undefined && result.data.carrierStatus[i].materialType != "" ? result.data.carrierStatus[i].materialType : result.data.carrierStatus[i].originalMaterialType;
              this.messagesService.addErrorMessage({ severity: 'error', summary: 'Inconsistent carrier', detail: result.data.carrierStatus[i].barcode + ' has different material:- ' + differntMaterialType });
              this.checkForDifferentMaterials(result.data, i + 1);
            }
          }
        }
        this.updateCarrierVisibility()

        this.blocked = false;
      }
        ,
        error => {
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.blocked = false;
        }
      );
    }
  }

  addNewCarrier(carrierType: string) {
    this.dynamicGridRows = 8;
    this.dynamicGridColumns = 12;
    this.isLoadStandardPrimerPlate = false;
    this.isHamiltonRack = false;
    let typeOfCarrier: CarrierType = carrierType == 'MIX2SEQ' ? CarrierType.MIX2SEQ : CarrierType.TUBE_CARRIER;

    let newCarrier: Carrier = { _id: null, scannerType: ScannerType.HANDSCANNER, carrierType: typeOfCarrier, barcode: 'BB_01', errors: null, rackPosition: '1', state: null, containerItems: null, orientation: null, scanDate: null, creationDate: null, scanResultFileName: null, isOpenForEdit: true, isDirty: false, visible: true, lab: this.selectedLab.lab, errorCount: 0, containerType: ContainerType.CARRIER, materialType: null, isSavedAfterScan: false, originalMaterialType: null, storageLocationOfContainer: null, carrierStatus: null, wellType: null };

    newCarrier.barcode = "BB" + Math.random().toString(36).substring(2, 6);
    newCarrier.scanDate = (new Date).getTime();

    this._carrierService.addCarrier(newCarrier).subscribe(
      result => {
        if (!result) {
          return;
        }
        result.data[0].isOpenForEdit = true;
        result.data[0].isSavedAfterScan = false;
        this.carriers.unshift(result.data[0]);

        this.selectedCarrier = result.data[0];
        this.updateCarrierVisibility();
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Added Carrier', detail: 'Added carrier' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }


  addNewSupremeRunCarrier() {
    this.dynamicGridRows = 8;
    this.dynamicGridColumns = 12;
    this.isLoadStandardPrimerPlate = false;
    this.isHamiltonRack = false;
    let typeOfCarrier: CarrierType = CarrierType.SR_TUBE_CARRIER;


    let newCarrier: Carrier = { _id: null, scannerType: ScannerType.HANDSCANNER, carrierType: typeOfCarrier, barcode: '', errors: null, rackPosition: '1', state: null, containerItems: null, orientation: null, scanDate: null, creationDate: null, scanResultFileName: null, isOpenForEdit: true, isDirty: false, visible: true, lab: this.selectedLab.lab, errorCount: 0, containerType: ContainerType.CARRIER, materialType: null, isSavedAfterScan: false, originalMaterialType: null, storageLocationOfContainer: null, carrierStatus: null, wellType: null };


    newCarrier.scanDate = (new Date).getTime();

    this._carrierService.saveSRCarrier(newCarrier).subscribe(
      result => {
        if (!result) {
          return;
        }
        result.data.isOpenForEdit = true;
        result.data.isSavedAfterScan = false;
        this.carriers.unshift(result.data);

        this.selectedCarrier = result.data;
        console.log("selected carrier", this.selectedCarrier);
        this.updateCarrierVisibility();
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Added SR Carrier', detail: 'Added carrier successfully' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }

  addNewPrimerCarrier() {
    this.dynamicGridRows = this.rowCol.row;
    this.dynamicGridColumns = this.rowCol.col;

    if (this.dynamicGridColumns == 0 && this.dynamicGridRows == 0) {
      this.isLoadStandardPrimerPlate = true;
    } else {
      this.isLoadStandardPrimerPlate = false;

      let typeOfCarrier: CarrierType = this.rowCol.row == 10 ? CarrierType.TUBE_RACK : CarrierType.PLATE_CARRIER;

      let newCarrier: Carrier = { _id: null, scannerType: ScannerType.HANDSCANNER, carrierType: typeOfCarrier, barcode: "", errors: null, rackPosition: '1', state: null, containerItems: null, orientation: null, scanDate: null, creationDate: null, scanResultFileName: null, isOpenForEdit: true, isDirty: false, visible: true, lab: this.selectedLab.lab, errorCount: 0, containerType: ContainerType.CARRIER, materialType: MaterialType.Primer, isSavedAfterScan: false, originalMaterialType: null, storageLocationOfContainer: null, carrierStatus: null, wellType: null };

      newCarrier.scanDate = (new Date).getTime();

      this._carrierService.addCarrier(newCarrier).subscribe(
        result => {
          if (!result) {
            return;
          }
          result.data[0].isOpenForEdit = true;
          this.carriers.unshift(result.data[0]);

          this.selectedCarrier = result.data[0];
          this.updateCarrierVisibility();
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Added Carrier', detail: 'Added carrier' });
          this.rowCol = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.blocked = false;
        }
      );
    }
  }

  addCarriersFromScanner(scannerType: string) {
    this.blocked = true;

    this._carrierService.getCarriersFromGenericScanner(this.selectedLab.lab, scannerType).subscribe(
      results => {
        if (!results || !results.data || results.data.length == 0) {
          this.messagesService.addErrorMessage({ severity: 'error', summary: 'NO CARRIERS RETRIEVED', detail: 'No carriers could be scanned' });
          this.blocked = false;
          return;
        }
        results.data.forEach(
          element => {
            element.isSavedAfterScan = false;
            element.isOpenForEdit = true;
            this.carriers.push(element);
          });
        this.selectedCarrier = results.data[0];
        this.updateCarrierVisibility();

        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Added Carrier', detail: 'Added carrier' });
        this.blocked = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );

  }

  addLightRunplates(plateBarcode: string): void {
    // null check
    if (!plateBarcode) {
      this.messagesService.addErrorMessage({ severity: 'error', summary: 'Barcode is required', detail: 'Please enter a valid Plate barcode' });
      return
    }
    // duplicate check
    this._carrierService.hasDuplicateBarcode(plateBarcode, this.selectedLab.lab).subscribe(results => {
      if (results.data) {
        this.messagesService.addErrorMessage({ severity: 'error', summary: 'Duplicate barcode', detail: 'Barcode already exist' });
        this.displayLRPlatesDialog = true;
      } else {
        //logic for setting the Carrier with the required parameters.
        this.displayLRPlatesDialog = false;
        let scanResults = new Carrier();
        scanResults.containerItems = new Array<ContainerItem>();
        scanResults.barcode = plateBarcode;
        scanResults.carrierType = CarrierType.PLATE_CARRIER;
        scanResults.scannerType = ScannerType.HANDSCANNER;
        scanResults.containerType = ContainerType.CARRIER;
        scanResults.lab = this.selectedLab.lab;

        this._carrierService.addCarrier(scanResults).subscribe(internalResults => {
          if (!internalResults) {
            return;
          }
          this.dynamicGridRows = 8;
          this.dynamicGridColumns = 12;
          internalResults.data[0].isSavedAfterScan = false;
          this.carriers.unshift(internalResults.data[0]);
          this.updateCarrierVisibility();
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Added Carrier', detail: 'Added carrier' });
        },
          error => {
            let message = this.errorHandler.handleError(error);
            this.messagesService.addErrorMessage(message);
            this.blocked = false;
          }
        );
      }
    },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }


  toCarrierItem(plateBarcode: string, positionRow: number, positionCol: number, material): ContainerItem {
    var barcode = plateBarcode + "_" + this.GetWellPosition(positionRow, positionCol);
    return {
      barcode, positionCol, positionRow, scanTime: null, isInternal: false, hasDuplicate: false, containerItemError: null, qcType: null
      , containerItemAware: null, primerName: null, hasDifferntMaterials: null

    }
  }

  GetWellPosition(row: number, col: number): string {
    var result = this.alphabet[row - 1] + col;
    return result;
  }


  updateCarrierTableWithNewCarriers() {
    this.blocked = true;
    this._carrierService.getCarrier(this.selectedLab.lab, this.pageIndex, this.fromDate.toDateString(), this.checkedWIP, this.checkedSC, this.checkedLP).subscribe(
      results => {
        if (!results || !results.data) {
          this.blocked = false;
          return;
        }
        let carriersAdded: number = 0;

        for (let i = 0; i < results.data.length; i++) {
          let carrierExisting: boolean = false;

          for (let j = 0; j < this.carriers.length; j++) {
            if (this.carriers[j]._id == results.data[i].id) {
              carrierExisting = true;
              break;
            }
          }
          if (!carrierExisting) {
            results.data[i].isSavedAfterScan = false;
            this.carriers.push(results.data[i]);
            carriersAdded++;
          }
        }
        this.updateCarrierVisibility();
        this.blocked = false;
        if (carriersAdded === 0) {
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'No new carriers', detail: 'No new carriers have been added.' });
        }
        else {
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'New Carriers', detail: carriersAdded + ' new carriers have been added.' });
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }

  openDeleteDialog(carrier: Carrier, index: number) {
    this.carrierToBeDeleted = carrier;
    this.deleteIndex = index;
    this.displayDeleteDialog = true;
    this.deleteConfirmed = true;
  }

  deleteCarrier() {
    this.displayDeleteDialog = false;
    this._carrierService.deleteCarrier(this.carrierToBeDeleted).subscribe(
      results => {
        if (!results) {
          return;
        }
        // remove the tab if opened for this element
        this.carriers.forEach(
          element => {
            if (this.carrierToBeDeleted._id == element._id) {
              var index = this.carriers.indexOf(element);
              this.closeTabOnDelete(this.deleteIndex);
              this.carriers.splice(index, 1);
            }
          });
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Deleted Carrier', detail: 'deleted carrier' });
        this.carrierToBeDeleted = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }

  getVisibleCarriers(): Array<Carrier> {
    let visibleCarriers: Array<Carrier>;

    if (this.carriers !== undefined && this.carriers !== null) {
      visibleCarriers = new Array<Carrier>();
      this.carriers.forEach(
        element => {
          if (element.visible) {
            visibleCarriers.push(element);
          }
        });
      return visibleCarriers;
    }
    return null;
  }

  getOpenedCarriers(): Array<Carrier> {
    let openedCarriers: Array<Carrier>;
    if (this.carriers !== undefined && this.carriers !== null) {
      openedCarriers = new Array<Carrier>();
      this.carriers.forEach(
        element => {
          if (element.isOpenForEdit) {
            openedCarriers.push(element);
          }
        });
      return openedCarriers;
    }
    return null;
  }

  updateCarrierVisibility() {
    if (this.carriers) {
      this.carriers.forEach(
        element => {
          if (!element.state ||
            element.state && (
              (this.checkedWIP && element.state.toString() == "WORK_IN_PROGRESS") ||
              (this.checkedSC && element.state.toString() == "COMPLETE") ||
              (this.checkedLP && element.state.toString() == "LAB_PROCESSING"))
          ) {
            element.visible = true;
          }
          else {
            element.visible = false;
          }
        });
    }
  }

  showLRPlatesDialog() {
    this.displayLRPlatesDialog = true;
    this.enteredPlateBarcode = null;
  }

  getStateAsString(carrier: Carrier): string {
    if (carrier !== undefined && carrier !== null && carrier.state !== undefined && carrier.state !== null) {
      if (carrier.state.toString() == "COMPLETE") {
        return 'SC';
      }
      else if (carrier.state.toString() == "WORK_IN_PROGRESS") {
        return 'WIP';
      }
      else if (carrier.state.toString() == "LAB_PROCESSING") {
        return 'LP';
      }
    }
    else {
      return "";
    }
  }



  private checkForDuplicates() {

    if (this.selectedCarrier === undefined || this.selectedCarrier === null) {
      return;
    }
    let carrierItemsOfSelectedCarrier: Array<ContainerItem> = this.selectedCarrier.containerItems;

    if (carrierItemsOfSelectedCarrier === undefined || carrierItemsOfSelectedCarrier === null || carrierItemsOfSelectedCarrier.length === 0) {
      return;
    }
    let barcodeMap: number[] = [];
    let count: number = 0;
    // collect amount per barcode
    carrierItemsOfSelectedCarrier.forEach(
      element => {
        let barcodeAmount: number = barcodeMap[element.barcode];
        if (element.containerItemAware != undefined && element.containerItemAware != null) {
          barcodeAmount = barcodeMap[element.barcode];

          if (barcodeAmount !== undefined && barcodeAmount !== null) {
            barcodeMap[element.barcode] = barcodeAmount + 1;
            if (barcodeAmount == 1) {
              count++;
            }
          }
          else {
            barcodeMap[element.barcode] = 1;
          }
        }

      });
    this.selectedCarrier.errorCount = count;
    // mark the duplicates
    carrierItemsOfSelectedCarrier.forEach(
      element => {
        let barcodeAmount: number = barcodeMap[element.barcode];
        element.hasDuplicate = barcodeAmount > 1;
      });

  }


  //Button clicks for complete scan, order processing and save carriers
  //To save the scan grid in Mix2seq
  onCompleteScanForPremix() {

    this.blocked = true;
    let completeScanRequest: CompleteScanRequest = new CompleteScanRequest(this.selectedCarrier, this.selectedCarrier.barcode, this.selectedLab.lab);
    this._carrierService.completeScan(completeScanRequest).subscribe(
      result => {
        if (!result) {
          this.blocked = false;
          return;
        }
        var oldCarrier = this.selectedCarrier;

        if (this.selectedCarrier.carrierType.toString() == "Mix2Seq") {
          result.data.forEach(element => {
            if (element._id == oldCarrier._id) {
              this.selectedCarrier = element;
              this.updateScannedCarrier(element, result.bbApiError, result.sequencerControllerFileContent, oldCarrier);
            }
            else {
              this.updateScannedCarrier(element, null, null, null);
            }

          });
          this.blocked = false;
        }
        else {
          this.selectedCarrier = result.data;
          this.updateScannedCarrier(result.data, result.bbApiError, result.sequencerControllerFileContent, oldCarrier);
          this.blocked = false;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        if (message.summary == 'Unprocessable Entity') {
          this.updateUponError(error);
        }
        this.blocked = false;
      }
    );


  }
  onCompleteScanForSR() {
    this.blocked = true;
    this.selectedCarrier.state = State.COMPLETE;

    this._carrierService.saveSRCarrier(this.selectedCarrier).subscribe(
      result => {
        if (!result) {
          return;
        }
        this.blocked = false;
        this.carrierUpdater(result.data);
        this.enableDownloadTRTFile = true;
        this.disableScanCompleteOnError = true;
        this.updateScannedCarrier(result.data, null, null, this.selectedCarrier);
        if (result.bbApiError.title && result.bbApiError.title != "") {
          if (result.bbApiError.title === "Feign client Exception") {
            this.disableScanCompleteOnError = false;
            this.enableDownloadTRTFile = false;
            this.messagesService.addErrorMessage({ severity: 'error', summary: result.bbApiError.title, detail: 'While updating the reaction sets! Please click on scan complete buttton again' });
          }
          else {
            this.messagesService.addErrorMessage({ severity: 'error', summary: result.bbApiError.title, detail: "EESB failed to send the message" });

          }
        }

      },
      error => {
        this.enableDownloadTRTFile = false;
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;

      });
  }

  onCompleteScan() {
    this.isSupremeRun(this.selectedCarrier) ? this.onCompleteScanForSR() : this.onCompleteScanForPremix();
  }

  updateScannedCarrier(data, bbApiError, sequencerControllerFileContent, oldCarrier) {
    var chosenId = oldCarrier == null ? data._id : this.selectedCarrier._id;
    for (let i = 0; i < this.carriers.length; i++) {

      if (this.carriers[i]._id == chosenId) {

        if (oldCarrier == null) {
          let changedCarrier = this.carriers[i];
          this.carriers[i] = data;
          this.carriers[i].containerItems = data.containerItems;
          this.carriers[i].isOpenForEdit = changedCarrier.isOpenForEdit;
          this.carriers[i].visible = changedCarrier.visible;
          this.carriers[i].isDirty = changedCarrier.isDirty;

          for (var j = 0; j < this.carriers[i].containerItems.length; j++) {
            this.carriers[i].containerItems[j].hasDuplicate = changedCarrier.containerItems[j].hasDuplicate;
            this.carriers[i].containerItems[j].isInternal = changedCarrier.containerItems[j].isInternal;
          }
          this.messagesService.addWarningMessage({ severity: 'warn', summary: 'Modified Carrier', detail: changedCarrier.barcode });
        }
        else {
          this.carriers[i] = data;
          this.carriers[i].isOpenForEdit = oldCarrier.isOpenForEdit;
          this.carriers[i].visible = oldCarrier.visible;
          this.carriers[i].isDirty = oldCarrier.isDirty;
          let controllerFileContent = sequencerControllerFileContent;

          if (controllerFileContent != null) {
            let blob: Blob = new Blob([controllerFileContent], { type: 'text/plain' });
            let fileName: string = data.barcode + '.txt';
            console.log(fileName)
            saveByFileSaver(blob, fileName);
          }

          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Scan Complete', detail: 'Scanned Carrier' });

          if (bbApiError) {
            this.messagesService.addAllErrorMessages(this.errorHandler.handleBBApiErrors(bbApiError));
          }
        }
        break;
      }
    }
  }

  saveCarrierBarcodesForPremix() {
    this.displaySaveBarcodesDialog = false;
    this.selectedCarrier.isDirty = false;
    let carrier: Carrier = this.selectedCarrier;

    // adding the Sample material while saving in Sample reception
    carrier.containerItems.forEach(function (ci) {
      if (carrier.materialType != null && carrier.materialType == MaterialType.Primer) {
        let materialContent: Primer = new Primer();
        materialContent.type = MaterialType.Primer;
        materialContent.barcode = ci.barcode;
        ci.containerItemAware = materialContent;
      }
      else {
        let materialContent: Sample = new Sample();
        materialContent.type = MaterialType.Sample
        materialContent.barcode = ci.barcode
        ci.containerItemAware = materialContent;
      }

    });

    var oldCarrier = this.selectedCarrier;

    this._carrierService.saveCarrier(carrier).subscribe(
      result => {
        if (!result) {
          return;
        }


        result.data.forEach(element => {
          if (element._id == oldCarrier._id) {
            element.isSavedAfterScan = true;
            this.selectedCarrier = element;
            if (result.bbApiError != null && result.bbApiError.title == "Warning") {
              this.messagesService.addWarningMessage({ severity: 'warn', summary: 'Primer Types', detail: result.bbApiError.message });
            }
          }
          else if (element.materialType == MaterialType.Primer) {
            this.updateScannedCarrier(element, null, null, null);
          }
        });

        let dirtyCarrierIndex = -1;
        for (let i = 0; i < this.carriers.length; i++) {
          if (this.carriers[i]._id == this.selectedCarrier._id) {
            this.carriers[i] = this.selectedCarrier;
            this.carriers[i].isOpenForEdit = carrier.isOpenForEdit;
            this.carriers[i].visible = carrier.visible;
            this.carriers[i].isDirty = carrier.isDirty;
            dirtyCarrierIndex = i;
            break;
          }
        }

        if (this.hasInvalidMaterials(this.selectedCarrier)) {
          if (dirtyCarrierIndex > -1) {
            this.carriers[dirtyCarrierIndex].isDirty = true;
          }
          if (result.bbApiError != null && result.bbApiError.title == "Rescan Error") {
            this.messagesService.addErrorMessage({ severity: 'error', summary: 'Rescan Error', detail: result.bbApiError.message });
          } else {
            this.messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Barcode', detail: 'Barcode is not registered in Blueberry' });
          }
        } else {
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Saved Carrier', detail: 'Saved carrier' });
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }

  saveCarrierBarcodesForSupremeRun() {
    let carrier: Carrier = this.selectedCarrier;

    this._carrierService.saveSRCarrier(this.selectedCarrier).subscribe(
      result => {
        if (!result) {
          return;

        }
        this.blocked = false;
        this.selectedCarrier = result.data;
        this.selectedCarrier.isSavedAfterScan = true;
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Saved carrier', detail: 'Barcodes has been saved successfully' });
        for (let i = 0; i < this.carriers.length; i++) {
          if (this.carriers[i]._id == this.selectedCarrier._id) {
            this.carriers[i] = this.selectedCarrier;
            this.carriers[i].isOpenForEdit = carrier.isOpenForEdit;
            this.carriers[i].visible = carrier.visible;
            this.carriers[i].isDirty = carrier.isDirty;
            break;
          }
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );

  }

  saveCarrierBarcodes() {
    this.isSupremeRun(this.selectedCarrier) ? this.saveCarrierBarcodesForSupremeRun() : this.saveCarrierBarcodesForPremix();
  }

  onTabclose(event) {

    let openedCarriers = this.getOpenedCarriers();
    if (openedCarriers === null || openedCarriers.length == 0) {
      return;
    }
    let carrierToClose: Carrier = openedCarriers[event.index];
    this.TabToclose = event.index;
    if (carrierToClose.isDirty) {
      this.displaySaveBarcodesDialog = true;
      return;
    }

    this.closeTab();

  }

  closeTabOnDelete(index: number) {
    let openedCarriers = this.getOpenedCarriers();
    if (openedCarriers === null || openedCarriers.length == 0) {
      return;
    }
    this.TabToclose = index;
    this.closeTab();
  }

  closeTab() {
    let openCarriers = this.getOpenedCarriers();
    if (openCarriers === null || openCarriers.length == 0) {
      return;
    }
    let carrierToClose: Carrier = openCarriers[this.TabToclose];
    carrierToClose.isOpenForEdit = false;
    // if (carrierToClose !== this.selectedCarrier) {
    //   return;
    // }
    if (this.carriers !== undefined && this.carriers !== null && this.carriers.length > 0) {
      if (this.TabToclose != 0) {
        this.selectedCarrier = openCarriers[0];
      } else {
        this.selectedCarrier = openCarriers[1];
      }
    }
    else {
      this.selectedCarrier = null;
    }
  }

  closeWithoutSavingBarcodes() {
    this.displaySaveBarcodesDialog = false;
    this.selectedCarrier.isDirty = false;
    var selectedCarrierId = this.selectedCarrier._id;
    this.closeTab();

    this._carrierService.getcarrierById(selectedCarrierId).subscribe(result => {
      if (!result || !result.data) {
        return;
      }
      // this.selectedCarrier.carrierItems=result.data.carrierItems;
      for (let i = 0; i < this.carriers.length; i++) {
        if (this.carriers[i]._id == selectedCarrierId) {
          this.carriers[i].containerItems = result.data.carrierItems;
          break;
        }
      }
    });

  }

  onTabChange(event) {
    let openedCarriers = this.getOpenedCarriers();
    if (openedCarriers === null || openedCarriers.length == 0) {
      return;
    }
    let carrierToChangeTo: Carrier = openedCarriers[event.index];
    this.selectedCarrier = carrierToChangeTo;
    this.selectedCarrier.carrierType === CarrierType.HAMILTON_RACK ? this.isHamiltonRack = true : this.isHamiltonRack = false;
    this.setDynamicGridDimensions();
  }

  createProcessingOrder() {
    this.blocked = true;
    this._carrierService.createOrderProcessing(this.selectedLab.lab).subscribe(results => {
      if (!results.data) {
        this.blocked = false;
        return;
      }
      results.data.forEach(element => {
        for (let i = 0; i < this.carriers.length; i++) {
          if (this.carriers[i]._id == element._id) {
            this.carriers[i].state = element.state;
            break;
          }
        }
      })

      this.blocked = false;
      this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: 'orders processed' });
    }, error => {
      if (!error) {
        this.blocked = false;
        return;
      }
      let message = this.errorHandler.handleError(error);
      this.messagesService.addErrorMessage(message);
      this.blocked = false;
    });

  }


  //Get Process Step definition on tab change for selected Step
  getProcessStepDetail(step: string) {

    this.getListOfPrinters();
    this.carrierStateDetails = null;

    this.carrierStatusService.getProcessStepDetails(step, this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("[Sample Reception - CS] -> " + step + "-> ", results.data);
        this.carrierStateDetails = results.data;
        if (!this.carrierStateDetails) {
          this.messagesService.addErrorMessage({ severity: 'error', summary: results.bbApiError.title, detail: results.bbApiError.message });
        } else {
          if (this.carrierStateDetails.printer.active)
            this.selectedPrinter = this.carrierStateDetails.printer;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }


  //Get list of active printers for selected lab
  getListOfPrinters() {
    this.carrierStatusService.getPrintersList(this.selectedLab.lab, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("[SampleReception] Printers List -> ", results.data);
        this.printersList = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }


  //On Print label click, print request will be sent to print service with selected printer
  onReprint() {
    let prinetreq: PrintRequest = new PrintRequest();

    prinetreq.printer = this.selectedPrinter;
    prinetreq.barCode.push(this.selectedCarrier.barcode);
    prinetreq.lab = this.selectedLab.lab;

    console.log("[Sample Reception --> Print Request] : ", prinetreq);

    this._carrierService.reprintLabel(prinetreq).subscribe(
      result => {
        if (!result) {
          return;
        }
        this.messagesService.addSuccessMessage({ severity: 'success', summary: result.data, detail: result.data });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    );
  }

  onReExport() {
    this._carrierService.reExport(this.selectedCarrier).subscribe(
      result => {
        if (!result) {
          return;
        }
        let controllerFileContent = result.sequencerControllerFileContent;
        let blob: Blob = new Blob([controllerFileContent], { type: 'text/plain' });
        let fileName: string = result.data.barcode + '.txt';
        saveByFileSaver(blob, fileName);
        this.blocked = false;
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Downloaded successful', detail: 'Downloaded ABI Sequencer file' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    );
  }

  isButtonDisabled(carrier: Carrier) {
    var isWIP = this.getStateAsString(carrier) == this.carrierState;
    var isError = carrier.errorCount ? carrier.errorCount > 0 : false;
    var noSamples = carrier.containerItems === undefined || carrier.containerItems === null || carrier.containerItems.length === 0;
    return !isWIP || isError || noSamples;
  }

  isDeleteButtonDisabled(carrier: Carrier) {
    return this.getStateAsString(carrier) != this.carrierState;
  }

  private validateCarrierItems(barcode: any): boolean {
    if (this.bbApiError !== undefined && this.bbApiError != null && this.bbApiError.errors != null) {
      let subErr = this.bbApiError.errors.find(el => el.code == barcode);
      return subErr != null;
    }
    return false;
  }


  getTotalErrorCount(carrier: Carrier) {

    let totalErrorcount = 0;

    if (carrier !== undefined && carrier !== null && carrier.containerItems !== undefined && carrier.containerItems !== null)
      carrier.containerItems.forEach(carrierItem => {
        if (carrierItem.containerItemError)
          totalErrorcount++;
      })
    if (carrier !== undefined && carrier !== null && carrier.errorCount)
      totalErrorcount += carrier.errorCount;

    return totalErrorcount;
  }

  private updateUponError(error: any) {
    if (error.error.data) {
      var oldCarrier = this.selectedCarrier;
      this.selectedCarrier = error.error.data;
      for (let i = 0; i < this.carriers.length; i++) {
        if (this.carriers[i]._id == this.selectedCarrier._id) {
          this.carriers[i] = error.error.data;
          this.carriers[i].isOpenForEdit = oldCarrier.isOpenForEdit;
          this.carriers[i].visible = oldCarrier.visible;
          this.carriers[i].isDirty = oldCarrier.isDirty;
          break;
        }
      }
    }
  }

  hasInvalidMaterials(carrier: Carrier) {
    for (let j = 0; j < carrier.containerItems.length; j++) {
      let containerItem = carrier.containerItems[j];
      if (containerItem.containerItemAware != null && containerItem.containerItemAware != undefined) {
        if (containerItem.containerItemAware.inValid == true) {
          return true;
        }
      }
    }
    return false;
  }
  setDynamicGridDimensions() {
    if (this.selectedCarrier.carrierType.toString() == "TUBE_RACK") {
      this.dynamicGridColumns = 10;
      this.dynamicGridRows = 10;
    }
    else {
      this.dynamicGridColumns = 12;
      this.dynamicGridRows = 8;
    }
  }

  // the file to be uploaded is selected
  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('profile').setValue(file);
      this.isUploadDisabled = false;
    } else {
      this.isUploadDisabled = true;
    }

  }

  // on upload of the selected file
  onSubmit() {
    const formData = new FormData();
    formData.append('file', this.uploadForm.get('profile').value);
    formData.append('labId', this.selectedLab.lab._id);
    this._carrierService.uploadStandatrdPrimer(formData).subscribe(
      result => {
        if (!result) {
          return;
        }
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Standard Primer Uploaded', detail: 'Upload Successful' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }
  chooseScanType(selection: any) {
    console.log("selection value:", selection.value)
    if (selection.value === "SR plate scan") {
      console.log('sr plate scan')
      this.addNewCarrier(CarrierType.TUBE_CARRIER)
    }
    else
      console.log('premix')
  }

  carrierUpdater(event) {
    let carrier = this.carriers.filter(carr => { return event._id === carr._id })
    if (carrier != null && carrier != undefined) {
      var index = this.carriers.indexOf(carrier[0]);
      this.carriers.splice(index, 1)
      event.isOpenForEdit = true;
      event.isSavedAfterScan = false;
      this.carriers.unshift(event);
      this.selectedCarrier = event
      this.updateCarrierVisibility()
    }
  }

  isSupremeRun(carrier: Carrier) {
    var carrierTypeArray: Array<CarrierType> = [CarrierType.PREMIXED_DNA, CarrierType.PURIFIED_DNA, CarrierType.UNPURIFIED_PCR, CarrierType.READY_TO_LOAD, CarrierType.CLONE, CarrierType.SR_TUBE_CARRIER, CarrierType.HAMILTON_CARRIER]
    return carrierTypeArray.includes(carrier.carrierType) || "HAMILTON" === carrier.scannerType.toString() && MaterialType.Primer === carrier.materialType
  }

  saveCarrierBarcodesForHamilton() {
    let carrier: Carrier = this.selectedCarrier;
    this._carrierService.saveHamiltonCarrier(this.selectedCarrier).subscribe(
      result => {
        if (!result) {
          return;

        }
        this.blocked = false;
        this.selectedCarrier = result.data;
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Saved carrier', detail: 'Barcodes has been saved successfully' });
        for (let i = 0; i < this.carriers.length; i++) {
          if (this.carriers[i]._id == this.selectedCarrier._id) {
            this.carriers[i] = this.selectedCarrier;
            this.carriers[i].isOpenForEdit = carrier.isOpenForEdit;
            this.carriers[i].visible = carrier.visible;
            this.carriers[i].isDirty = carrier.isDirty;
            break;
          }
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );

  }

  emptyHamiltonCarrier() {
    if (this.selectedCarrier != null && this.selectedCarrier.containerItems != null && this.selectedCarrier.containerItems.length > 0) {
      this._carrierService.emptyHamiltonRack(this.selectedCarrier).subscribe(
        result => {
          if (!result) {
            return;
          }
          let carrier = this.carriers.filter(carr => { return this.selectedCarrier._id === carr._id })
          if (carrier != null && carrier != undefined) {

            var index = this.carriers.indexOf(carrier[0]);
            this.carriers.splice(index, 1)
            this.selectedCarrier = result.data;
            this.selectedCarrier.isOpenForEdit = true;
            this.carriers.unshift(this.selectedCarrier);
            this.updateCarrierVisibility();
          }

          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Barcodes Deleted !', detail: 'Carrier is Empty' });

        },
        error => {
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.blocked = false;
        }
      );
    }
  }

  saveOrFetchCarrier(barcode: string) {
    this.isHamiltonRack = true;
    this.isLoadStandardPrimerPlate = false;
    let typeOfCarrier: CarrierType = CarrierType.HAMILTON_RACK;

    let newCarrier: Carrier = { _id: null, scannerType: ScannerType.HANDSCANNER, carrierType: typeOfCarrier, barcode: '', errors: null, rackPosition: '1', state: null, containerItems: [], orientation: null, scanDate: null, creationDate: null, scanResultFileName: null, isOpenForEdit: true, isDirty: false, visible: true, lab: this.selectedLab.lab, errorCount: 0, containerType: ContainerType.CARRIER, materialType: null, isSavedAfterScan: false, originalMaterialType: null, storageLocationOfContainer: null, carrierStatus: null, wellType: null };
    newCarrier.scanDate = (new Date).getTime();
    newCarrier.barcode = barcode;
    if (barcode != "" && barcode != null && barcode != undefined) {
      this.blocked = true;
      this._carrierService.saveHamiltonCarrier(newCarrier).subscribe(
        result => {
          if (!result) {
            return;
          }
          this.blocked = false;
          this.HamiltonRackDialog = false;
          this.enteredRackBarcode = '';
          this.hamiltonCarrierUpdater(result.data);
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Tube Rack', detail: 'barcode added successfully' });
        },
        error => {
          this.enteredRackBarcode = '';
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
        }
      );
    }
  }
  hamiltonCarrierUpdater(event) {
    let carrier = this.carriers.filter(carr => { return event._id === carr._id })
    if (carrier != null && carrier != undefined && carrier.length > 0) {
      var index = this.carriers.indexOf(carrier[0]);
      this.selectedCarrier = event;
      this.carriers.splice(index, 1, this.selectedCarrier);
    }
    else {
      this.selectedCarrier = event
      this.carriers.unshift(this.selectedCarrier);
    }
    this.selectedCarrier.isOpenForEdit = true;
    this.updateCarrierVisibility()

  }

  ifNoMaterialAvailableInCarrier(carrier: Carrier) {
    if (carrier.containerItems === undefined || carrier.containerItems === null || carrier.containerItems.length === 0) { return true; }
    return false;
  }

  checkForDifferentMaterials(carrier: Carrier, rackPosition) {
    let startPosition;
    let endPosition
    if (rackPosition == 1) {
      startPosition = 1
      endPosition = 4
    }
    else if (rackPosition == 2) {
      startPosition = 5
      endPosition = 8
    }
    else {
      startPosition = 9
      endPosition = 12
    }
    for (let i = startPosition; i < endPosition; i++) {
      carrier.containerItems.forEach(item => {
        if (item.positionCol == i) {
          item.hasDifferntMaterials = true;
        }
      })
    }
  }

  showScanCompleteButton(carrier: Carrier) {
    return (carrier != null && carrier !== undefined && carrier.scannerType != null) &&
      (carrier.materialType == null || MaterialType.Sample === carrier.materialType || ("HAMILTON" === carrier.scannerType.toString() && MaterialType.Primer === carrier.materialType));
  }

  onDownLoadTRTFile(barcode: string) {
    this.blocked = true;
    this._carrierService.getTRTFile(barcode).subscribe(
      result => {
        if (!result || result.data == "" || result.data == undefined || result.data == null) {
          this.messagesService.addInfoMessage({ severity: 'info', summary: 'File content not found!', detail: barcode })
          return;
        }
        this.blocked = false;
        let fileContent = result.data;
        let blob: Blob = new Blob([fileContent], { type: 'text/plain' });
        let scanResultFileNameArray = this.selectedCarrier.scanResultFileName.split("_");
        let trtFileName = "TRT" + "_" + scanResultFileNameArray[1] + "_" + barcode + "_" + scanResultFileNameArray[2] + "_" + scanResultFileNameArray[3];
        saveByFileSaver(blob, trtFileName);
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    );
  }
  getState(carrier: Carrier) {
    return carrier.state == State.COMPLETE || carrier.state.toString() == State[1].toString() || carrier.materialType === MaterialType.Primer;
  }

  isTRSFile(carrier: Carrier) {
    return carrier.scanResultFileName != null && carrier.scanResultFileName != undefined && "TRS" === carrier.scanResultFileName.substring(0, 3);
  }

  isStateComplete(carrier: Carrier) {
    return carrier.state == State.COMPLETE || carrier.state.toString() == State[1].toString();
  }
  storeFocusLocation(event) {
    this.storeLocation = event;
  }
  storeIsVertical(event) {
    this.storeVertical = event;
  }

  storeFocusLocationForHamiltonRack(event) {
    this.storeLocationForHamiltonRack = event;
  }
}

